import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
} from "recharts";
import "./ChartCard.css";

/**
 * BarChartCard generic
 * props:
 *  - data: array de obiecte [{ name: 'Locul 1', value: 10 }, ...]
 *  - title: titlul de sus
 *  - xKey: cheie pentru X (default: 'name')
 *  - yKey: cheie pentru valoare (default: 'value')
 *  - height: înălțime chart (default: 250)
 */
export default function BarChartCard({
  data = [],
  title = "Distribuție poziții",
  xKey = "name",
  yKey = "value",
  height = 250,
}) {
  return (
    <div className="chart-card">
      <h3>{title}</h3>
      <ResponsiveContainer width="100%" height={height}>
        <BarChart data={data}>
          <CartesianGrid strokeDasharray="3 3" vertical={false} />
          <XAxis dataKey={xKey} stroke="#aaa" />
          <YAxis stroke="#aaa" allowDecimals={false} />
          <Tooltip cursor={{ fill: "transparent" }}/>
          <Bar dataKey={yKey} fill="#3b82f6" radius={[4, 4, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
